export default __webpack_public_path__ + "static/media/n-back-movement-step1.367e780c.svg";